import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_ENDPOINTS, fetchWithCredentials } from '../config/api';
import './PaymentSuccessPage.css';

function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/auth');
      return;
    }

    const orderId = searchParams.get('orderId');
    if (!orderId) {
      navigate('/orders');
      return;
    }

    const fetchOrder = async () => {
      try {
        const response = await fetchWithCredentials(`${API_ENDPOINTS.ORDERS.GET_ORDER}/${orderId}`);
        if (response && response.order) {
          setOrder(response.order);
        } else {
          setError('訂單不存在或已過期');
        }
      } catch (err) {
        setError('獲取訂單信息失敗');
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [searchParams, isLoggedIn, navigate]);

  if (loading) {
    return (
      <div className="payment-success-page">
        <div className="container">
          <div className="loading">加載中...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-success-page">
        <div className="container">
          <div className="error-message">{error}</div>
          <button className="back-button" onClick={() => navigate('/orders')}>
            返回訂單列表
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="container">
        <div className="success-card">
          <div className="success-icon">✓</div>
          <h1>支付成功</h1>
          <div className="order-details">
            <p>訂單號：{order.orderNumber}</p>
            <p>金額：${order.amount} {order.currency}</p>
            <p>支付方式：{order.paymentMethod}</p>
            {order.serialNumber && (
              <div className="serial-number-section">
                <h2>您的序列號</h2>
                <div className="serial-number">
                  {order.serialNumber.serialKey}
                </div>
                <p className="serial-number-note">
                  序列號已發送到您的郵箱，請妥善保管。
                </p>
              </div>
            )}
          </div>
          <div className="action-buttons">
            <button className="primary-button" onClick={() => navigate('/orders')}>
              查看訂單
            </button>
            <button className="secondary-button" onClick={() => navigate('/')}>
              返回首頁
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessPage; 